import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Rating,
  TextField,
  Typography,
} from "@mui/material"
import * as Style from "./style"
import moment from "moment"

import { useNavigate, useParams } from "react-router-dom"
import { FaChevronLeft } from "react-icons/fa"
import StarIcon from "@mui/icons-material/Star"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import {
  useCreateReviewPostMutation,
  useProviderReviewsQuery,
} from "../../features/Auth/authApi"
import dummy from "../../images/dummy-image.jpg"
import { toast } from "react-toastify"
import CenteredSpinner from "../common/CenteredSpinner"
import { FormatChangeTime } from "../common/utctolocalDate"
interface ReviewProps {
  message: string
}

const WriteReview = () => {
  const [values, setValues] = React.useState<number | null>(null)
  const urlSearchParams = new URLSearchParams(window.location.search)
  const postIdProvider = urlSearchParams.get("postId")
  const { data: seekerReview, isLoading: isloadingSeekers } =
    useProviderReviewsQuery({})
  const [reviewPost, { data, error, isLoading }] = useCreateReviewPostMutation()
  const [errorloading, setErrorLoading] = useState<boolean>(false)
  const { id } = useParams()
  const navigate = useNavigate()
  const schemaResolver = yup.object().shape({
    message: yup.string().required("Please fill the Mandatory fields."),
  })

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<ReviewProps, any>({
    resolver: yupResolver(schemaResolver),
  })

  const onSubmit = (value: any) => {
    const trimmedMessage = value?.message?.trim() || ""

    const wordCount = trimmedMessage.split(/\s+/).filter(Boolean).length

    if (values === null || values < 0) {
      toast.error("Please Provide A Valid Rating.", { autoClose: 800 })
      setErrorLoading(true)
      setTimeout(() => {
        setErrorLoading(false)
      }, 1000)
      return
    }

    if (trimmedMessage.length === 0) {
      toast.error("Message Is Required.", { autoClose: 800 })
      setErrorLoading(true)
      setTimeout(() => {
        setErrorLoading(false)
      }, 1000)
      return
    }

    if (wordCount > 200) {
      toast.error("Message Exceeds The Maximum Length Of 200 Words.", {
        autoClose: 800,
      })
      setErrorLoading(true)
      setTimeout(() => {
        setErrorLoading(false)
      }, 1000)
      return
    }

    const payload = {
      seekerData: id,
      rating: values,
      message: value?.message,
      postId: postIdProvider,
    }
    reviewPost(payload)
  }

  useEffect(() => {
    if (data?.message) {
      navigate("/dashboard/rating")
      toast.success(data?.message)
    } else {
      toast.error((error as any)?.data?.message)
    }
  }, [data, error])

  useEffect(() => {
    if ((errors as any)?.message?.message) {
      toast.error((errors as any)?.message?.message)
    }
  }, [errors])

  return (
    <>
      {isloadingSeekers ? (
        <CenteredSpinner />
      ) : (
        <>
          <Style.Overview>
            <Box className="d-flex align-items-center gap-4 mb-4">
              <Button
                className="back-btn mb-0"
                onClick={() => navigate(`/dashboard/rating`)}
              >
                <FaChevronLeft />
              </Button>
              <Typography className="font-20 service-text pink-text fw-semibold mb-0">
                Write Review
              </Typography>
            </Box>
          </Style.Overview>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Style.Overview>
                <Box>
                  <Typography
                    variant="body1"
                    className="text-start text-black fw-bold pt-2 pb-3"
                  >
                    Service Customer
                  </Typography>
                  <Box className="seeker-card" style={{ maxHeight: '450px', overflowY: 'auto', paddingRight: '8px' }}>
                    <Box className="d-flex gap-2 align-items-center mb-3">
                      <Box>
                        <img
                          src={
                            seekerReview?.data?.[0]?.seekerData?.profilePic ||
                            dummy
                          }
                          className="seeker-img rounded"
                          style={{ width: "50px", height: "50px" }}
                        />
                      </Box>
                    </Box>

                    {/* Name */}
                    <Box
                      sx={{
                        border: "1px solid lightgray",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, color: "#000", mb: 1 }}
                      >
                        Name
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#333" }}>
                        {seekerReview?.data?.[0]?.seekerData?.name}
                      </Typography>
                    </Box>

                    {/* Service */}
                    <Box
                      sx={{
                        border: "1px solid lightgray",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, color: "#000", mb: 1 }}
                      >
                        Service
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#333" }}>
                        {seekerReview?.data?.[0]?.service?.name}
                      </Typography>
                    </Box>

                    {/* Date */}
                    <Box
                      sx={{
                        border: "1px solid lightgray",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, color: "#000", mb: 1 }}
                      >
                        Date
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#333" }}>
                        {moment(seekerReview?.data?.[0]?.from).format(
                          "ddd-DD-MMM"
                        )}
                      </Typography>
                    </Box>

                    {/* Time */}
                    <Box
                      sx={{
                        border: "1px solid lightgray",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, color: "#000", mb: 1 }}
                      >
                        Time
                      </Typography>
                      <Typography
                        variant="body2"
                        className="d-flex"
                        sx={{ color: "#333" }}
                      >
                        <FormatChangeTime
                          dateString={seekerReview?.data?.[0]?.from}
                        />{" "}
                        -{" "}
                        <FormatChangeTime
                          dateString={seekerReview?.data?.[0]?.till}
                        />
                      </Typography>
                    </Box>

                    {/* Location */}
                    <Box
                      sx={{
                        border: "1px solid lightgray",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, color: "#000", mb: 1 }}
                      >
                        Location
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#333" }}>
                        {seekerReview?.data?.[0]?.location}
                      </Typography>
                    </Box>

                    {/* Status */}
                    <Box
                      sx={{
                        border: "1px solid lightgray",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, color: "#000", mb: 1 }}
                      >
                        Status
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#333" }}>
                        {seekerReview?.data?.[0]?.status}
                        <span className="status-text completed"></span>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Style.Overview>
            </Grid>

            <Grid item xs={12} md={8}>
              <Style.Overview>
                <Box className="write-review-card">
                  <Typography
                    variant="body1"
                    className="text-center pink-text mb-2 fw-semibold"
                  >
                    How Would You Rate Service Customer{" "}
                    <span className="text-danger">*</span>
                  </Typography>
                  <Box className="d-flex justify-content-center align-items-center gap-3 mb-5">
                    <Rating
                      name="hover-feedback"
                      value={values}
                      onChange={(event, newValue) => {
                        setValues(newValue);
                      }}
                      emptyIcon={
                        <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                      }
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="body1"
                      className="pink-text fw-semibold mb-4"
                    >
                      Write A Review <span className="text-danger">*</span>
                    </Typography>
                    <TextField
                      id="outlined-textarea"
                      placeholder="Write Your Review Here...."
                      multiline
                      rows={4}
                      className="review-field w-100 mb-3"
                      {...register("message")}
                    />

                    <Box className="text-end mt-3">
                      <Button
                        className="view-profile text-capitalize"
                        onClick={handleSubmit(onSubmit)}
                      >
                        {isLoading ? (
                          <Typography fontSize={1}>
                            <CircularProgress
                              style={{ color: "pink", fontSize: 20 }}
                              size={20}
                            />
                          </Typography>
                        ) : (
                          " Send"
                        )}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Style.Overview>
            </Grid>
          </Grid>
        </>
      )}
    </>

  )
}
export default WriteReview
